import { InferSelectModel } from 'drizzle-orm';
import type { languagesTable } from '../api-server/services/db/schema/content';

export type Language = InferSelectModel<typeof languagesTable> & { code: LanguageCode };

export enum LanguageCode {
  English = 'en',
  Spanish = 'es',
  Portuguese = 'pt',
}

export function isLanguageCode(code: string | LanguageCode | unknown): code is LanguageCode {
  return Object.values(LanguageCode).includes(code as LanguageCode);
}

export function toLanguageCode(code: string | LanguageCode | unknown): LanguageCode {
  if (!isLanguageCode(code)) {
    return LanguageCode.English; // Default to English if not recognized
  }
  return code;
}

export const Flags = [
  { code: LanguageCode.English, flag: '🇺🇸' },
  { code: LanguageCode.Spanish, flag: '🇪🇸' },
  { code: LanguageCode.Portuguese, flag: '🇧🇷' },
];
